// Determine API base URL (without /api suffix for this file)
const getApiBase = () => {
  // Check environment variables first
  if (process.env.REACT_APP_API_URL) {
    // Remove /api suffix if present since we add it below
    let url = process.env.REACT_APP_API_URL;
    if (url.endsWith('/api')) {
      return url.slice(0, -4);
    }
    return url;
  }
  if (process.env.NEXT_PUBLIC_API_URL) {
    let url = process.env.NEXT_PUBLIC_API_URL;
    if (url.endsWith('/api')) {
      return url.slice(0, -4);
    }
    return url;
  }
  
  // Server-side rendering or no window
  if (typeof window === 'undefined') {
    return 'http://localhost:5000';
  }
  
  const hostname = window.location.hostname;
  
  // Production domain
  if (hostname === 'www.intellinoteai.com' || hostname === 'intellinoteai.com') {
    return 'https://api.intellinoteai.com';
  }
  
  // Vercel preview deployments
  if (hostname.includes('.vercel.app')) {
    return window.location.origin;
  }
  
  // Local development
  return 'http://localhost:5000';
};

const API_BASE = getApiBase();
console.log('API_BASE in config/api.ts:', API_BASE);

export const API_ENDPOINTS = {
  auth: `${API_BASE}/api/v1/auth`,
  users: `${API_BASE}/api/v1/users`,
  notes: `${API_BASE}/api/v1/notes`,
  flashcards: `${API_BASE}/api/v1/flashcards`,
  ai: `${API_BASE}/api/v1/ai`,
  waitlist: `${API_BASE}/api/v1/waitlist`,
};
